const GardenerFormInstructions = () => (
    <div className="instructions">
        <h2>Instructions</h2>
        <p><b>Personal Information:</b> This section keeps your details updated.</p>
        <p><b>Name:</b> How you'll be referenced in emails, texts, and report.</p>
        <p><b>Contact Method:</b> Choose how to receive gardening tasks and reports.</p>
        <p><b>Location:</b> Determines your planting guide and weather station.</p>
        <p>You can update any of these fields at any time. Simply press the <b>Update Gardener</b> button to save your changes.</p>
        <h2>Plants Section</h2>
        <p><b>Supported Plants:</b> Only the plants within the drop-down box are supported.</p>
        <p><b>Add a Plant:</b> Select the plants you want to grow and press <b>Add Plant</b>. The plant will appear in the right sidebar.</p>
        <p><b>Remove a Plant:</b> Select a plant from the dropdown box and press <b>Remove Plant</b> to remove it from the right sidebar.</p>
        <p>Only the plants within the right sidebar will appear in your report and tasks.</p>
    </div>
);

export default GardenerFormInstructions;
